import React from 'react';
import {store} from './../../index'
import { ModalTitle, ModalBody } from '@vds/modals';
import { apiUrl } from '../../constants/apiUrl';
import { TextLink } from '@vds/buttons';
import { dataTrack } from '../../service/vzdl';

let vzigInstance = '';
let cancelClick = false;
class SignInMHVerification extends React.PureComponent {
    constructor(props) {
      super(props);
      this.vzigInstanceCallBack = this.vzigInstanceCallBack.bind(this);
      this.retryVerification = this.retryVerification.bind(this);
      this.state = {
        loaderStatus: false,
        loaderSpin: true,
        cancelClicked: false,
        initialized: false,
      };
    }
  
    componentDidMount() {
      try {
        let igVerificationInitialedFlag = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.igVerificationInitialed;
        if (!this.state.initialized && !igVerificationInitialedFlag) {
            this.props.dispatch({type: 'MNH_IG_VERIFICATION_START', value: true });
            this.setState({ initialized: true });
            cancelClick = false;
            const { transactionID } = this.props.buildproduct.mnhTokenGenerationResponse;
            const igBackendUrl = apiUrl().pollingIGBackendUrl;
            const { deviceID } = this.props.buildproduct.mnhTokenGenerationResponse.data.listOfDevices[0];
            const initialPayload = {
                transactionID,
                connType: 'POLLING',
                igBackendUrl,
                callBackFunction: this.vzigInstanceCallBack,
            };
            vzigInstance = new VZIGCVSCore(initialPayload);
            vzigInstance.startVerification(deviceID);
        }
      } catch (e) {
        if (e.message.indexOf('VZIGCVSCore') > -1) {
          this.invokeScript();
          setTimeout(() => {
            this.retryVerification();
          }, 4000);
        } else {
          this.props.dispatch({type: 'MNH_IG_VERIFICATION_START', value: true });
          this.setState({ initialized: true, loaderStatus: false, loaderSpin: false });
          this.props.verificationAPIListener();
        }
      }
    }
  
    vzigInstanceCallBack(response) {
      if (response != null) {
        if (response.responseCode === '20') {
          // verification successfull Scenario proceeding to BAU
          this.setState({ loaderStatus: false, loaderSpin: false });
          this.props.dispatch({type: 'SET_MNH_STATUS', value: 'Y' });
          this.props.verificationAPIListener();
        } else if (response.responseCode === '10' || response.responseCode === '11' || response.responseCode === '12' || response.responseCode === '13' || response.responseCode === '14') {
          // SMS sent successful
          this.setState({ loaderStatus: true, loaderSpin: false });
        } else if (response.responseCode === '02' || response.responseCode === '03' || response.responseCode === '06' || response.responseCode === '07' || response.responseCode === '09') {
          // Error, inValid, maz attempt reached
          this.props.dispatch({type: 'SET_MNH_STATUS', value: 'maxAttempt' });
          this.setState({ loaderStatus: false, loaderSpin: false });
          this.props.verificationAPIListener();
        } else if (response.responseCode === '00' && cancelClick) {
          // cancelation success when clicked cancel
          this.props.dispatch({type: 'SET_MNH_STATUS', value: 'cancel' });
          this.setState({ loaderStatus: false, loaderSpin: false });
          this.props.verificationAPIListener();
        } else if (response.responseCode === '00') {
          // Intialised sent successful
          this.setState({ loaderStatus: false, loaderSpin: false });
        } else {
          this.setState({ loaderStatus: false, loaderSpin: false });
          this.props.dispatch({type: 'SET_MNH_STATUS', value: 'cancel' });
          this.props.verificationAPIListener();
        }
      }
    }
  
    onClickCancel = (e) => {
      e.preventDefault();
      if(vzigInstance){
        vzigInstance.cancelVerification();
      }
      cancelClick = true;
      this.setState({ loaderStatus: false, loaderSpin: true, cancelClicked: true });
      if(this.props.buildproduct?.isMNEnabled || this.props.buildproduct?.mnFromApi){ this.props?.closeModel(); }
    };
  
    invokeScript = () => {
      try {
        const igtransactionID  = this.props?.buildproduct?.mnhTokenGenerationResponse?.transactionID;
        let transactionIDStartsWith = igtransactionID?.substring(0,2);
        let igScriptURL = 'https://scache-ws.vzw.com/am/aa/aa/assets/js/vzigaaplugin.min.js';
        if(this.props?.lqState?.runtimeKey?.isNewAAURLFlowEnabled === 'Y'){
          if ((window.location.host === 'www.verizon.com' || window.location.host === 'preprod-east-gz.vpc.verizon.com' || window.location.host === 'espanol.verizon.com')) {
            if(transactionIDStartsWith == 'W-'){
                igScriptURL = 'https://scache-ws.vzw.com/am/aa/aa/assets/js/vzigaaplugin.min.js';
            } else if(transactionIDStartsWith == 'N-'){
                igScriptURL = 'https://scache-ws.vzw.com/am/aa/nsa/assets/js/vzigaaplugin.min.js';
            }
          } else {
            if(transactionIDStartsWith == 'W-'){
                igScriptURL = 'https://stcache-ws.vzw.com/am/aa/aa/assets/js/vzigaaplugin.min.js';
            } else if(transactionIDStartsWith == 'N-'){
                igScriptURL = 'https://stcache-ws.vzw.com/am/aa/nsa/assets/js/vzigaaplugin.min.js';
            }
          }
        } else {
          if ((window.location.host === 'www.verizon.com' || window.location.host === 'preprod-east-gz.vpc.verizon.com' || window.location.host === 'espanol.verizon.com')) {
            igScriptURL = 'https://scache-ws.vzw.com/am/aa/aa/assets/js/vzigaaplugin.min.js';
          } else {
              igScriptURL = 'https://stcache-ws.vzw.com/am/aa/aa/assets/js/vzigaaplugin.min.js';
          }
        }
        
        const fileref = document.createElement('script');
        fileref.setAttribute('async', true);
        fileref.setAttribute('defer', 'defer');
        fileref.setAttribute('src', igScriptURL);
        document.getElementsByTagName('head')[0].appendChild(fileref);
        
      } catch (e) {
        //console.log('Error in Retry vzigaaplugin Script call');
      }
    };
  
    retryVerification = () => {
      try {
        const { transactionID } = this.props.buildproduct.mnhTokenGenerationResponse;
        const igBackendUrl = apiUrl().pollingIGBackendUrl;
        const { deviceID } = this.props.buildproduct.mnhTokenGenerationResponse.data.listOfDevices[0];
        const initialPayload = {
          transactionID,
          connType: 'POLLING',
          igBackendUrl,
          callBackFunction: this.vzigInstanceCallBack,
        };
        vzigInstance = new VZIGCVSCore(initialPayload);
        vzigInstance.startVerification(deviceID);
      } catch (e) {
        this.setState({ initialized: true, loaderStatus: false, loaderSpin: false });
        this.props.verificationAPIListener();
      }
    };
  
    onCancelKeyDown = (e) => {
      if (e.charCode === 13) {
        this.onClickCancel(e);
      }
    };
  
    render() {
      return (
        <div className='mnhValidation ResknModalHeader'>
            <ModalTitle>
              We've sent a notification to <br/>{this.props.updatedMobileNumber}               
            </ModalTitle>
            <ModalBody>
              <div>
                  <p>Respond to the notification on your device and return to this screen to continue.</p>
                  <p>Waiting for response...</p>
                  <TextLink onClick={this.onClickCancel} onKeyPress={(e) => this.onCancelKeyDown(e)} data-track={dataTrack('link', 'cancel')} >
                      Cancel
                  </TextLink>
              </div>
            </ModalBody>
        </div>
      );
    }
  }

export default SignInMHVerification
